<script setup lang="ts">
const { total, itemsPerPage, currentPage, onPageChange, paginationClass }
  = defineProps(['total', 'itemsPerPage', 'currentPage', 'onPageChange', 'paginationClass'])

const route = useRoute()
function to(page: number) {
  return {
    query: {
      ...route.query,
      page: page > 1 ? page : undefined,
    },
  }
}
</script>

<template>
  <div class="container-fluid">
    <UPagination
      v-if="total"
      :page="currentPage"
      aria-label="Pagination"
      color="primary"
      active-color="info"
      variant="ghost"
      :total="total ?? 0"
      :items-per-page="itemsPerPage ?? 10"
      :to="!onPageChange ? to : undefined"
      class="pagination flex 3xl:max-w-block-wide max-md:justify-center"
      :class="[paginationClass ?? '']"
      :sibling-count="0"
      show-edges
      v-on="onPageChange ? { 'update:page': onPageChange } : {}"
    />
  </div>
</template>
